import React, { memo } from "react";
import { RiQuestionLine } from "react-icons/ri";
import Help, { ARTICLES } from "../../../help/Help";
import { useHelpContext } from "../../../../contexts/HelpContext";

function HelpWidget({ metricPathPrefix }: { metricPathPrefix: string[] }) {
    const helpContext = useHelpContext();

    return (
        <Help
            articleId={helpContext.getArticleId() ?? ARTICLES.HOME_PAGE_V3}
            buttonClassName="btn btn-ghost-gray btn-small btn-icon-only"
            metricPathPrefix={[...metricPathPrefix, "help"]}
            button={(
                <div className="btn-icon">
                    <RiQuestionLine />
                </div>
            )}
        />
    );
}

export default memo(HelpWidget);
